import { jsx as _jsx } from "react/jsx-runtime";
import DOMPurify from 'dompurify';
import { Typography } from '@emburse/embark-core';
export default function SafeHtmlTypography({ children }) {
    // Sanitize HTML content
    const sanitizedHTML = DOMPurify.sanitize(children);
    return (_jsx(Typography, { children: _jsx("span", { dangerouslySetInnerHTML: { __html: sanitizedHTML } }) }));
}
